module.exports = __webpack_public_path__ + "media/images/account-white-5b07830d4b81651ba4200203bdf5a1d9.svg";